import { FileName, SceneConfig, Navigator } from '@oop/data';
import { includes } from 'ramda';

export const LazyLoadRenders = (
  initialRender: FileName,
  currentRenders: FileName[],
  sceneConfig: Record<string, SceneConfig<unknown>>,
  depth: number
) => {
  let actualRenders = [...currentRenders];
  let initialNavigators = sceneConfig[initialRender].navegadores;
  const pushRFNIfNeeded = (n: Navigator) => {
    if (!n) return;
    if (!includes(n.to, actualRenders)) {
      actualRenders.push(n.to);
    }
  };
  const pushNavigatorsIfPossible = (na: Navigator[], currDepth: number) => {
    if (currDepth === depth) return;
    na.forEach(pushRFNIfNeeded);
    const navigators = na.map((naa) => {
      if (!sceneConfig[naa.to]) return []; // If this config isn't implemented yet return
      return sceneConfig[naa.to].navegadores;
    });
    navigators.forEach((ns) => pushNavigatorsIfPossible(ns, currDepth + 1));
  };
  pushNavigatorsIfPossible(initialNavigators, 0);
  return actualRenders;
};
